module.exports = __webpack_public_path__ + "static/media/failed-icon.260cb995.svg";